__turbopack_context__.v({
  "agent": "ContactForm-module__fsVPKa__agent",
  "agentAvatar": "ContactForm-module__fsVPKa__agentAvatar",
  "agentInfo": "ContactForm-module__fsVPKa__agentInfo",
  "form": "ContactForm-module__fsVPKa__form",
  "formCard": "ContactForm-module__fsVPKa__formCard",
  "input": "ContactForm-module__fsVPKa__input",
  "row": "ContactForm-module__fsVPKa__row",
  "submitBtn": "ContactForm-module__fsVPKa__submitBtn",
  "textarea": "ContactForm-module__fsVPKa__textarea",
});
